import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  Grid,
  TextField,
  Container,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import { logEventos } from "../../../services/services";

const FacturasForm = ({
  isEditMode,
  rowInfo,
  handleOpenCloseModalForm,
  obtenerFacturas,
  mostrarAlertaTemporal,
}) => {
  const [data, setData] = useState({
    id: isEditMode ? rowInfo.id : undefined,
    parametro: isEditMode ? rowInfo.parametro : "",
    valor: isEditMode ? rowInfo.valor : 0,
    descripcion: isEditMode ? rowInfo.descripcion : "",
    activo: isEditMode ? rowInfo.activo : 1,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    logEventos(
      isEditMode ? "Editar factura" : "Agregar factura",
      "Factura",
      isEditMode ? "Editar una factura" : "Crear una factura",
      localStorage.getItem("user")
    );

    let isValidForm = true;

    if (!data.parametro || !data.valor || data.valor <= 0) {
      mostrarAlertaTemporal(
        "Por favor, complete todos los campos requeridos.",
        "error"
      );
      isValidForm = false;
    }

    if (isValidForm) {
      const newFactura = {
        activo: data.activo,
        parametro: data.parametro,
        valor: parseFloat(data.valor),
        descripcion: data.descripcion,
      };

      const url = isEditMode
        ? `${UrlApi}/facturasParametros/${rowInfo.id}`
        : `${UrlApi}/facturasParametros`;
      const method = isEditMode ? "PUT" : "POST";

      try {
        const response = await fetch(url, {
          method,
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newFactura),
        });

        const data = await response.json();

        if (response.ok) {
          mostrarAlertaTemporal(
            isEditMode
              ? "Actualización realizada correctamente"
              : "Factura agregada con éxito",
            "success"
          );
          obtenerFacturas();
          handleOpenCloseModalForm();
        } else {
          mostrarAlertaTemporal(
            `Error al ${isEditMode ? "actualizar" : "agregar"} la factura: ${
              data.message
            }`,
            "error"
          );
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
        mostrarAlertaTemporal("Hubo un problema con la solicitud.", "error");
      }

      handleOpenCloseModalForm();
    }
  };

  return (
    <Dialog
      open={true}
      onClose={handleOpenCloseModalForm}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="lg"
      fullWidth
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#1F618D",
          width: "100%",
          marginBottom: 4,
        }}
      >
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="center"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              {isEditMode ? "Editar Factura" : "Agregar Nueva Factura"}
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <Container>
        <Grid container spacing={5}>
          <Grid item xs={12} sx={{ marginTop: 2 }}>
            <TextField
              fullWidth
              label="Parámetro"
              required
              name="parametro"
              value={data.parametro}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Valor"
              required
              name="valor"
              type="number"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              value={data.valor}
              onChange={handleChange}
              inputProps={{ min: 0 }}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              sx={{ overflow: "hidden" }}
              scro
              fullWidth
              label="Descripción"
              name="descripcion"
              value={data.descripcion}
              inputProps={{ maxLength: 200 }}
              helperText={`${data.descripcion.length}/200 caracteres`}
              onChange={handleChange}
              variant="outlined"
              multiline
              rows={3}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: 3,
            }}
          >
            <Button
              variant="contained"
              color="error"
              onClick={handleOpenCloseModalForm}
            >
              Volver
            </Button>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              {isEditMode ? "Guardar Cambios" : "Agregar Factura"}
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
  );
};

export default FacturasForm;
